export const DATE_FORMAT = 'DD.MM.YYYY'
export const DATE_AND_TIME_FORMAT = 'DD.MM.YYYY HH:mm'

export const RUBLE = '₽'

export const E_ZIndexes = {
  Level1: 100, // Any
  Level2: 200, // Drawers
  Level4: 400, // Top and main bars
  Level6: 600, // Modals
  Level8: 800, // Drawer portal
  Level10: 1000, // Tutorial overlay
} as const

export const CACHE_BUSTER = `v${__APP_VERSION__}`
